"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnce = exports.useRStateArray = exports.useRState = exports.useRStateS = void 0;
var react_1 = require("react");
var core_1 = require("./core");
var long_array_1 = require("./long_array");
function useRStateS(initValue) {
    return react_1.useMemo(function () { return core_1.stateS(initValue); }, []);
}
exports.useRStateS = useRStateS;
function useRState(initValue, options) {
    return react_1.useMemo(function () { return core_1.state(initValue, options); }, []);
}
exports.useRState = useRState;
function useRStateArray(initValues) {
    return react_1.useMemo(function () { return long_array_1.stateArray(initValues); }, []);
}
exports.useRStateArray = useRStateArray;
function useOnce(initFunc) {
    return react_1.useMemo(initFunc, []);
}
exports.useOnce = useOnce;
//# sourceMappingURL=func_use.js.map